var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"py-5 py-md-7 py-lg-8"},[(_vm.loading)?_c('LoadingWidget'):_c('v-container',{staticClass:"py-0"},[(_vm.title)?_c('TitleWidget',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }